/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
// import "./index.css";

// Redux Imports
import { useSelector } from "react-redux";

import Validation from "../../../../utils/validation";
import AccountName from "../../../_utils/AccountCreationComponents/AccountName";
import ContactDetails from "../../../_utils/AccountCreationComponents/ContactDetails";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import CommonLayout from "../../../_utils/CommonLayout";
import LinkEntityCard from "../../../_utils/LinkEntityCard";

const FieldForceContactDetails = (props) => {
  const [contactNumberValidation, setContactNumberValidation] = useState(false);
  const [emailValidation, setEmailValidation] = useState(false);
  const [customErrors, setCustomErrors] = useState({});
  const categories = props.categories;

  const handleRadioBtn = (event) => {
    props?.setSelectedValue(event.target.value);
    if (event.target.value === "legalname") {
      handleUpdateLegalName();
    } else if (event.target.value === "username") {
      handleUpdateUsername();
    }
  };

  const { panVerificationData } = useSelector((state) => state.sharedResources);

  const allCategoryIds = useMemo(() => {
    return categories.map((category) => category.id);
  }, []);
  const isAllSelected = useMemo(() => {
    return props?.selectedCatFields.length === allCategoryIds.length;
  }, [props?.selectedCatFields, allCategoryIds]);

  const handleUpdateLegalName = () => {
    props?.setPayload((prevPayload) => ({
      ...prevPayload,
      account_name: panVerificationData?.pan_details?.full_name,
    }));
    props?.setAccountNameValidation(true);
  };

  const handleUpdateUsername = () => {
    props.setPayload((prev) => ({
      ...prev,
      account_name: props.payload.userName,
    }));
  };

  const handleCategorySelect = (selectedCategories) => {
    let selectedCategoryNames = [];

    if (selectedCategories.length > GlobalConfiguration.lengthCheckZero) {
      selectedCategoryNames = selectedCategories
        .map((categoryId) => {
          const category = categories.find(
            (category) => category.id === categoryId,
          );
          return category ? category.id : null;
        })
        .filter((name) => name !== null);
    } else {
      selectedCategoryNames = categories.map((category) => category.id);
    }

    props.onSelectFieldsChange(selectedCategoryNames);
  };

  const emailRegex = Validation.emailRegex;

  const modifyValue = (type, value) => {
    if (type === "gstin") {
      return value?.toUpperCase();
    }
    return value.trim();
  };

  const allowedValue = (name, value) => {
    if (name === "contact_no") return Validation.allowedContactNum(value);
    if (name === "email_id") return Validation.allowedEmail(value);
    return true;
  };

  const validateAndRecordError = (name, value) => {
    let errors = { ...customErrors };
    if (name === "email_id")
      errors = Validation.validateEmail(name, value, errors);
    if (name === "contact_no")
      errors = Validation.validateContactNum(name, value, errors);

    setCustomErrors(errors);
  };

  const handleChange = (e) => {
    let { name, value } = e.target;
    if (name !== "account_name") {
      value = modifyValue(name, value?.replace(/\s/g, ""));
    } else {
      value = value.replace(/\s+/g, " ");
    }

    if (props.payload) {
      if (allowedValue(name, value)) {
        validateAndRecordError(name, value);
        const newObj = { ...props.payload, [name]: value };
        props?.setPayload(newObj);
      }
      if (
        props?.payload?.contact_no &&
        (props?.payload?.contact_no?.length ===
          GlobalConfiguration.lengthCheckZero ||
          props?.payload?.contact_no?.length < GlobalConfiguration.panLength)
      ) {
        setContactNumberValidation(false);
      }
      if (
        props?.payload?.email_id &&
        props?.payload?.email_id?.length === GlobalConfiguration.lengthCheckZero
      ) {
        setEmailValidation(false);
      }

      if (name === "account_name") {
        const trimmedLength = value.trim().length;

        if (trimmedLength > GlobalConfiguration.lengthCheckZero) {
          let matchedValue = "customname";
          if (value === panVerificationData?.pan_details?.full_name) {
            matchedValue = "legalname";
          } else if (value === props.payload.userName) {
            matchedValue = "username";
          }
          props?.setSelectedValue(matchedValue);

          const isCustomName = matchedValue === "customname";
          const meetsMinLength =
            !isCustomName ||
            trimmedLength >= GlobalConfiguration.lengthCheckThree;

          props?.setAccountNameValidation(meetsMinLength);
        } else {
          props?.setAccountNameValidation(false);
        }
      }
    }
  };

  useMemo(() => {
    if (customErrors["contact_no"]) {
      setContactNumberValidation(false);
    }
    if (
      !customErrors["contact_no"] &&
      props.payload.contact_no?.length === GlobalConfiguration.panLength
    ) {
      setContactNumberValidation(true);
    }
    if (customErrors["email_id"]) {
      setEmailValidation(false);
    }
    if (
      !customErrors["email_id"] &&
      props.payload.email_id?.length > GlobalConfiguration.lengthCheckZero &&
      emailRegex.test(props.payload.email_id)
    ) {
      setEmailValidation(true);
    }
  }, [contactNumberValidation, emailValidation, customErrors, props.payload]);

  useEffect(() => {
    if (
      emailValidation &&
      contactNumberValidation &&
      props?.accountNameValidation
    ) {
      props.BenEnableNextButton(false);
      props.parentCreateBen({
        email: emailValidation,
        contact: contactNumberValidation,
        accountname: props?.accountNameValidation,
      });
    } else if (props?.activeStep === GlobalConfiguration.lengthCheckTwo) {
      props.parentCreateBen({
        email: emailValidation,
        contact: contactNumberValidation,
        accountname: props?.accountNameValidation,
      });
      props.BenEnableNextButton(true);
    }
    handleCategorySelect(props?.selectedCatFields);
  }, [
    props?.selectedCatFields,
    isAllSelected,
    emailValidation,
    contactNumberValidation,
    props?.accountNameValidation,
    props?.activeStep,
  ]);

  const handleDivBtn = (value) => {
    props?.setSelectedValue(value);
    if (value === "legalname") {
      handleUpdateLegalName();
    } else if (value === "username") {
      handleUpdateUsername();
    }
  };

  return (
    <>
      <div className="px-padding-md lg:px-padding-base pb-padding-md py-padding-md Qsmd:py-padding-base">
        <CommonLayout>
          <LinkEntityCard
            payload={props?.payload}
            setPayload={props?.setPayload}
            selectedValue={props?.selectedValue}
            headerTitle="User view all"
            redirectPath="/settings/user_view_all"
            flow="fieldforceaccountcreate"
            title="User"
            description="Linked user will be able to create field force requests."
            buttonText="Link user"
          />
          <AccountName
            handleChange={handleChange}
            accountNameValidation={props?.accountNameValidation}
            accountName={props.payload.account_name}
            selectedValue={props?.selectedValue}
            handleDivBtn={handleDivBtn}
            handleRadioBtn={handleRadioBtn}
            selectedRadioValue={props?.selectedValue}
            legalName={props?.payload?.legalName}
            type={"user"}
            userName={props.payload.userName}
            setSelectedValue={props?.setSelectedValue}
            placeHolder={"Account name"}
          />

          <ContactDetails
            handleChange={handleChange}
            contactNumberValidation={contactNumberValidation}
            emailValidation={emailValidation}
            contactNumber={props.payload.contact_no}
            emailId={props.payload.email_id}
            selectedValue={props?.selectedValue}
          />
        </CommonLayout>
      </div>
    </>
  );
};

export default FieldForceContactDetails;
